import { environment } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
	providedIn: 'root',
})
export class PaymentSystemService extends BaseService {
	protected readonly EndPoint = environment.API_ENDPOINT + 'paymentMethods/';

	constructor(protected readonly http: HttpClient) {
		super(http);
	}

	filter(
		option: {
			take?: any;
			page?: any;
			searchTerm?: any;
			isActive?: any;
		} = {}
	): Observable<any> {
		return this.http.get(
			`${this.EndPoint}filter?take=${option.take || ''}&page=${
				option.page || ''
			}&searchTerm=${option.searchTerm || ''}&isActive=${option.isActive || ''}`
		);
	}
}
